export const IS_LOCAL = import.meta.env.MODE === 'development';
export const IS_DEV_BRANCH = !IS_LOCAL && window.location.origin.includes('.ktsdev.');
export const IS_KTS_DEMO = !IS_LOCAL && window.location.origin.includes('.ktsprod.');
export const IS_SUMMA = !IS_LOCAL && window.location.origin.includes('.summa.moscow');
export const IS_POKOLENIE = !IS_LOCAL && window.location.origin.includes('.pokolenie.one');

export type EnvType = 'local' | 'kts-demo' | 'summa' | 'pokolenie' | 'dev';

export const ENV_TYPE = ((): EnvType => {
  if (IS_LOCAL) {
    return 'local';
  }
  if (IS_KTS_DEMO) {
    return 'kts-demo';
  }
  if (IS_SUMMA) {
    return 'summa';
  }
  if (IS_POKOLENIE) {
    return 'pokolenie';
  }

  return 'dev';
})();
